<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: ESM Woocommerce to Hubspot Integration
      Author: Wibert Muza
    Author URL: https://esminbound.com
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <vs-tabs>
                  <vs-tab label="">
                    <login-firebase></login-firebase>
                  </vs-tab>
                </vs-tabs>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginFirebase from './LoginFirebase.vue'

export default {
  components: {
    LoginFirebase
  }
}

</script>

<style lang="scss">

  .login-tabs-container {
    min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      margin-top: 1rem;
    }

    .vs-con-input-label.is-label-placeholder {
      margin-top: 2rem;
    }
  }
#page-login {
  .vs-input--input.hasIcon:not(.icon-after-input) {
    &+.vs-input--placeholder {
      padding-left: 5px !important;
      -webkit-transform: translate(-3px,-70%)!important;
      transform: translate(-3px,-70%)!important;
    }
    &:focus+.vs-placeholder-label {
      padding-left: .7rem !important;
    }  
  }
  .con-ul-tabs {
      background-color: #1B1E31;
      display: none;
  }
  .con-slot-tabs {
    margin-top: -1rem;
  }
  .con-tab {
    padding-left: 0px;
  }
}
</style>
